import {
  $post
} from '@/utils/http'


// 导航栏设置
export default {
  // 查询导航栏
  NavigationTitleSearchApi(params) {
    return $post('Navigation/NavigationTitleSearch', params)
  },

  // 富文本查询
  NavigationContentSearchApi(params) {
    return $post('Navigation/NavigationContentSearch', params)
  },


  // 新闻查询
  NewsCenterManagementDataSearchApi(params) {
    return $post('EnterpriseQualification/NewsCenterManagementDataSearch', params)
  },

  // 首页新闻查询
  HomePageNewsSearchApi(params) {
    return $post('EnterpriseQualification/HomePageNewsSearch', params)
  },

  // 新闻详情查询
  SearchNewsByAOMIDApi(params) {
    return $post('EnterpriseQualification/SearchNewsByAOMID', params)
  },
}